import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { request } from "../api/config"

const initialState = {
    isLoading: false,
    success: false,
    message: null,
    products: [],
    product: null,
    isSubmit: false,
    successAction: false
}

export const getProducts = createAsyncThunk(
    'products/getProducts',
    async (thunkAPI) => {
        try {
            const res = await request('products')
            if(res.code === 200 || res.code === 11 || res.success === true) {
                return res.products || res.data || []
            } else {
                return thunkAPI.rejectWithValue(res.message || 'Houve um erro ao retornar os produtos')
            }
        } catch (e) {
            return thunkAPI.rejectWithValue('Houve um erro ao retornar os produtos')
        }
    }
)

export const getProduct = createAsyncThunk(
    'products/getProduct',
    async (values, thunkAPI) => {
        try {
            const res = await request(`products/${values.id}`)
            if(res.code === 200 || res.code === 11) {
                return res.product || res.data
            } else {
                return thunkAPI.rejectWithValue(res.message || 'Houve um erro ao retornar o produto')
            }
        } catch (e) {
            return thunkAPI.rejectWithValue('Houve um erro ao retornar o produto')
        }
    }
)

export const createProduct = createAsyncThunk(
    'products/createProduct',
    async (values, thunkAPI) => {
        try {
            const res = await request('products', 'POST', values)
            if(res.code === 200 || res.code === 201) {
                return res.product || res.data
            } else {
                return thunkAPI.rejectWithValue(res.message || 'Houve um erro ao criar o produto')
            }
        } catch (e) {
            return thunkAPI.rejectWithValue('Houve um erro ao criar o produto')
        }
    }
)

export const updateProduct = createAsyncThunk(
    'products/updateProduct',
    async (values, thunkAPI) => {
        try {
            const { id, ...data } = values
            const res = await request(`products/${id}`, 'PATCH', data)
            if(res.code === 200 || res.code === 201) {
                return res.product || res.data
            } else {
                return thunkAPI.rejectWithValue(res.message || 'Houve um erro ao atualizar o produto')
            }
        } catch (e) {
            return thunkAPI.rejectWithValue('Houve um erro ao atualizar o produto')
        }
    }
)

export const uploadProductFile = createAsyncThunk(
    'products/uploadFile',
    async (values, thunkAPI) => {
        try {
            const { productId, file } = values
            const formData = new FormData()
            formData.append('file', file)
            
            const res = await request(`products/${productId}/files`, 'POST', formData, true)
            if(res.code === 200 || res.code === 201) {
                return res.file || res.data
            } else {
                return thunkAPI.rejectWithValue(res.message || 'Houve um erro ao fazer upload do arquivo')
            }
        } catch (e) {
            return thunkAPI.rejectWithValue('Houve um erro ao fazer upload do arquivo')
        }
    }
)

export const deleteProductFile = createAsyncThunk(
    'products/deleteFile',
    async (values, thunkAPI) => {
        try {
            const res = await request(`products/files/${values.fileId}`, 'DELETE')
            if(res.code === 200 || res.code === 204) {
                return values.fileId
            } else {
                return thunkAPI.rejectWithValue(res.message || 'Houve um erro ao remover o arquivo')
            }
        } catch (e) {
            return thunkAPI.rejectWithValue('Houve um erro ao remover o arquivo')
        }
    }
)

const productsSlice = createSlice({
    name: 'products',
    initialState,
    extraReducers(builder) {
        builder
            .addCase(getProducts.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getProducts.fulfilled, (state, { payload }) => {
                state.isLoading = false
                state.success = true
                state.products = payload
            })
            .addCase(getProducts.rejected, (state, { payload }) => {
                state.isLoading = false
                state.success = false
                state.message = payload
            })
            .addCase(getProduct.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getProduct.fulfilled, (state, { payload }) => {
                state.isLoading = false
                state.success = true
                state.product = payload
            })
            .addCase(getProduct.rejected, (state, { payload }) => {
                state.isLoading = false
                state.success = false
                state.message = payload
            })
            .addCase(createProduct.pending, (state) => {
                state.isSubmit = true
            })
            .addCase(createProduct.fulfilled, (state, { payload }) => {
                state.isSubmit = false
                state.successAction = true
                state.product = payload
                state.products = [...state.products, payload]
            })
            .addCase(createProduct.rejected, (state, { payload }) => {
                state.isSubmit = false
                state.successAction = false
                state.message = payload
            })
            .addCase(updateProduct.pending, (state) => {
                state.isSubmit = true
            })
            .addCase(updateProduct.fulfilled, (state, { payload }) => {
                state.isSubmit = false
                state.successAction = true
                state.product = payload
                state.products = state.products.map(p => p.id === payload.id ? payload : p)
            })
            .addCase(updateProduct.rejected, (state, { payload }) => {
                state.isSubmit = false
                state.successAction = false
                state.message = payload
            })
            .addCase(uploadProductFile.pending, (state) => {
                state.isSubmit = true
            })
            .addCase(uploadProductFile.fulfilled, (state, { payload }) => {
                state.isSubmit = false
                state.successAction = true
                if(state.product && state.product.files) {
                    state.product.files = [...state.product.files, payload]
                } else if(state.product) {
                    state.product.files = [payload]
                }
            })
            .addCase(uploadProductFile.rejected, (state, { payload }) => {
                state.isSubmit = false
                state.successAction = false
                state.message = payload
            })
            .addCase(deleteProductFile.pending, (state) => {
                state.isSubmit = true
            })
            .addCase(deleteProductFile.fulfilled, (state, { payload }) => {
                state.isSubmit = false
                state.successAction = true
                if(state.product && state.product.files) {
                    state.product.files = state.product.files.filter(f => f.id !== payload)
                }
            })
            .addCase(deleteProductFile.rejected, (state, { payload }) => {
                state.isSubmit = false
                state.successAction = false
                state.message = payload
            })
    }
})

const { reducer } = productsSlice

export default reducer
